// Direct add to cart from size options (Quick Add Mobile)
document.addEventListener('DOMContentLoaded', function () {

  let popupShown = false;
  let quickAddInterval = null;

  // Cart updated popup
  document.addEventListener('cart:updated', function () {
    if (popupShown) return;

    popupShown = true;
    showCartPopup();

    setTimeout(() => {
      popupShown = false;
    }, 10000);
  });

  function showCartPopup() {
    const overlay = document.getElementById('cart-popup-overlay');

    if (!overlay) return;

    overlay.classList.add('active');

    clearTimeout(overlay._timer);

    overlay._timer = setTimeout(() => {
      overlay.classList.remove('active');
    }, 3000);
  }

  // Handle back button
  document.addEventListener('click', function (e) {
    const backBtn = e.target.closest('a.back-btn');

    if (!backBtn) return;

    e.preventDefault();

    const restockView = document.querySelector('.restock-notification-view');
    const quickAdd = document.querySelector('.hdt-main-product-quick-add');

    if (restockView) {
      restockView.style.display = 'none';
    }

    if (quickAdd) {
      quickAdd.style.display = '';
    }
  });

  // Handle variant selection
  document.addEventListener('change', function (e) {
    const variantInput = e.target.closest(
      '.variant-radio-opt input'
    );

    if (!variantInput) return;

    if (variantInput.type === 'radio' && !variantInput.checked) {
      return;
    }

    const variantOption = variantInput.closest('.variant-radio-opt');

    const restockView = document.querySelector(
      '.restock-notification-view'
    );

    const quickAdd = document.querySelector(
      '.hdt-main-product-quick-add'
    );

    // Handle out-of-stock variants
    if (variantOption?.classList.contains('out-of-stock-opt')) {
      if (restockView) {
        restockView.style.display = 'block';
      }

      if (quickAdd) {
        quickAdd.style.display = 'none';
      }

      return;
    }

    if (restockView) {
      restockView.style.display = 'none';
    }

    if (quickAdd) {
      quickAdd.style.display = '';
    }

    // Prevent auto add for sold-out variants
    if (variantOption?.querySelector('span.soldout-notify-icon')) {
      return;
    }

    // Clear any previous polling
    if (quickAddInterval) {
      clearInterval(quickAddInterval);
      quickAddInterval = null;
    }

    let attempts = 0;

    quickAddInterval = setInterval(() => {
      attempts++;

      // Re-locate the container from the live DOM
      const liveQuickAddContainer = document.querySelector(
        '.hdt-main-product-quick-add'
      );

      const currentBtn = liveQuickAddContainer?.querySelector(
        '.hdt-product-form__submit[name="add"]'
      );

      if (!currentBtn) {
        if (attempts > 200) {
          clearInterval(quickAddInterval);
          quickAddInterval = null;
        }

        return;
      }

      if (!currentBtn.disabled) {
        clearInterval(quickAddInterval);
        quickAddInterval = null;

        showCartPopup();

        currentBtn.click();

      } else if (attempts > 200) {
        clearInterval(quickAddInterval);
        quickAddInterval = null;
      }

    }, 700);
  });

});


// BOGO Sale Anniversary Functions
document.addEventListener('DOMContentLoaded', function () {

  const elements = document.querySelectorAll(
    '#hdt-menu-25th-anniversary-b1g1, button[data-category="25th-anniversary-b1g1"], .top-menu-mobile__list > :nth-child(5) a'
  );

  elements.forEach(function (element) {
    element.insertAdjacentHTML('afterbegin', `
      <svg
        class="anniversary-star"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          fill="goldenrod"
          d="M12 2l2.9 6.26L21.5 9l-5 4.87L17.8 21 12 17.6 6.2 21l1.3-7.13L2.5 9l6.6-.74L12 2z"
        ></path>
      </svg>
    `);
  });

});


// BOGO Sale Anniversary navigation
document.addEventListener('click', function (e) {

  const button = e.target.closest(
    '[data-category="25th-anniversary-b1g1"]'
  );

  if (!button) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  window.location.replace('/pages/anniversary-sale');

}, true);


// Add odd-media-count class for 3-in-a-row images
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.hdt-slider__container').forEach(function (container) {

    const itemCount = container.querySelectorAll(
      '.hdt-product__media-item'
    ).length;

    if (itemCount >= 5 && itemCount % 2 !== 0) {
      container.classList.add('odd-media-count');
    }

  });

});


// Open SYNCC links in a new tab

document.addEventListener('click', function (e) {
  const link = e.target.closest('a[data-item-name="SYNCC"], a.menu-link[href="https://wearsyncc.com/"]');
  
  if (link) {
    e.preventDefault();
    
    // Ensure attributes are set for accessibility/consistency, even if missing in markup
    link.setAttribute('data-item-name', 'SYNCC');
    link.setAttribute('rel', 'noopener noreferrer');
    
    window.open(link.href, '_blank', 'noopener,noreferrer');
  }
});

 // For centerizing the PDP images upon scroll through varaints selection

(function () {
  const orig = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (opts) {
    // only touch scrolls that target product gallery images
    if (this.closest('[class*="gallery"], [class*="media"], [class*="product-images"]')) {
      return orig.call(this, { behavior: 'smooth', block: 'center' });
    }
    return orig.call(this, opts);
  };
})();

 // For adding availability filter in check for collections and filtering availble size variants

(function () {
  if (window.__defaultAvailability) return;
  window.__defaultAvailability = true;

  var COLLECTION_RE = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^\/]+\/?$/i;
  var FORM_SEL = '#hdt-facet-filters-form';

  function hasUserParams(sp) {
    if (sp.has('sort_by')) return true;
    var found = false;
    sp.forEach(function (v, k) { if (k.indexOf('filter.') === 0) found = true; });
    return found;
  }

  function applyDefaults(u) {
    // u.searchParams.set('sort_by', 'manual');
    u.searchParams.set('filter.v.availability', '1');
    return u;
  }

  // 1. Direct visit: redirect before the page renders
  try {
    if (COLLECTION_RE.test(location.pathname)) {
      var cur = new URL(location.href);
      if (!hasUserParams(cur.searchParams)) {
        // location.replace(applyDefaults(cur).toString());
        return;
      }
    }
  } catch (e) {}

  // 2. Internal links: rewrite hrefs (initial DOM plus anything added later)
  function rewriteLink(a) {
    if (a.__defaulted) return;
    a.__defaulted = true;
    try {
      if (a.closest(FORM_SEL)) return; // leave filter / remove-filter links alone
      var u = new URL(a.getAttribute('href'), location.origin);
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname) return; // self links (e.g. "clear all")
      if (!COLLECTION_RE.test(u.pathname)) return;
      if (hasUserParams(u.searchParams)) return;
      // a.href = applyDefaults(u).toString();
    } catch (e) {}
  }

  function rewriteAll(root) {
    if (root.nodeType !== 1) return;
    // if (root.matches && root.matches('a[href*="/collections/"]')) rewriteLink(root);
    // root.querySelectorAll && root.querySelectorAll('a[href*="/collections/"]').forEach(rewriteLink);
  }

  function initLinks() {
    rewriteAll(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(rewriteAll); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // 3. Filter form: keep availability on unless a real checkbox controls it
  function syncAvailability(form) {
    var real = form.querySelector('input[name="filter.v.availability"]:not([data-auto-availability])');
    var hidden = form.querySelector('input[data-auto-availability]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'filter.v.availability';
      hidden.value = '1';
      hidden.setAttribute('data-auto-availability', '');
      form.appendChild(hidden);
    }
    hidden.disabled = !!real; // the visible checkbox wins; otherwise always on
  }

  ['change', 'submit', 'click', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var form = e.target.closest && e.target.closest(FORM_SEL);
      if (form) syncAvailability(form);
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinks);
  } else {
    initLinks();
  }
})();